import { PolicyDashboardEventsModule, SignatureTrackingModule } from '@korint/folio';

export function BrokerPolicyDashboardEventsView() {
  return (
    <div className="flex flex-col gap-4">
      <PolicyDashboardEventsModule stopFunnelBasePath="/policies" />
      <SignatureTrackingModule />
    </div>
  );
}
